import Checkbox from "atoms/forms/checkbox";
import React from "react";

interface SharedPageEntryProps {
    idOrScope: number;
    label: string;
    isChecked: boolean;
    isDisabled: boolean;
    onClick: (pageId: number) => void;
}

const CSS_CLASS_NAME = "c-shared-page-list";
const SharedPageEntry = (props: SharedPageEntryProps) => {
    const { idOrScope, label, isChecked, isDisabled, onClick } = props;

    const handleOnClick = () => {
        onClick(idOrScope);
    };

    return (
        <div className={`${CSS_CLASS_NAME}__entry`}>
            <Checkbox
                cssClassName={`${CSS_CLASS_NAME}__checkbox`}
                label={label}
                disabled={isDisabled}
                checked={isChecked}
                onChange={handleOnClick}
            />
        </div>
    );
};

export default SharedPageEntry;
